import axios from "axios";
import { JSON_URL } from "../../config/RouterLink";
import { bloqueoFechas } from "../../utils/funciones";

//------------- TYPES -------------------------

const FECHAS_CONCURSO = "[ASPIRANTE] FECHAS_CONCURSO";
const EXPEDIENTE = "[ASPIRANTE] EXPEDIENTE";
const BLOQUEO_POR_FECHA = "[ASPIRANTE] BLOQUEO_POR_FECHA";
const BLOQUEO_POR_POSTULACION = "[ASPIRANTE] BLOQUEO_POR_POSTULACION";
const CLEAN_STATE = "[ASPIRANTE] CLEAN_STATE";

//------------- STATE -------------------------
const initialState = {
  concurso: {},
  expediente: {},
  bloquearPorFecha: true,
};

//------------- REDUCER -------------------------
const estatusBloqueoAspirante = (state = initialState, action) => {
  switch (action.type) {
    case FECHAS_CONCURSO:
      return {
        ...state,
        concurso: action.payload,
      };
    case EXPEDIENTE:
      return {
        ...state,
        expediente: action.payload,
      };

    case BLOQUEO_POR_FECHA:
      return {
        ...state,
        bloquearPorFecha: action.payload,
      };
    case BLOQUEO_POR_POSTULACION:
      return {
        ...state,
        bloquearPorPostulacion: action.payload,
      };
    case CLEAN_STATE:
      return initialState;

    default:
      return state;
  }
};

export default estatusBloqueoAspirante;

//------------- ACTIONS -------------------------

export const setConcurso = (state) => ({
  type: FECHAS_CONCURSO,
  payload: state,
});
export const setExpediente = (state) => ({
  type: EXPEDIENTE,
  payload: state,
});

export const setDisableFecha = (state) => ({
  type: BLOQUEO_POR_FECHA,
  payload: state,
});

export const getEstatusBloqueo = (idFase = 1) => async (dispatch, getState) => {
  const { data } = await axios(window.location.origin + JSON_URL);
  const { idAspirante, accessToken } = getState().usuarioLogin;
  await axios
    .post(
      `${data.urlServer}${data.urlBloquearAspirante}`,
      { idAspirante, idFase },
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      }
    )
    .then((resp) => {
      const { data } = resp;
      const { fechaInicio, fechaFin } = data.concurso;
      const bloqueoPorFecha = bloqueoFechas(fechaInicio, fechaFin);
      //dispacths

      dispatch(setConcurso(data));
      dispatch(setDisableFecha(bloqueoPorFecha));
    })
    .catch((error) => {
      const { data } = error.response;
      console.error(data);
    });
};
export const getBloqueoExpediente = (idFase) => async (dispatch, getState) => {
  const { data } = await axios(window.location.origin + JSON_URL);
  const { idAspirante, accessToken } = getState().usuarioLogin;
  await axios
    .post(
      `${data.urlServer}${data.urlBloquearAspirante}`,
      { idAspirante, idFase },
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      }
    )
    .then((resp) => {
      const { data } = resp;
      // console.log(data.concurso)      
      dispatch(setExpediente(data));
    })
    .catch((error) => {
      const { data } = error.response;
      console.error(data);
    });
};
